let translationConfig = null

const setTranslationConfig = (data) => {
    translationConfig = data;
}

const getTranslationConfig = () => {
    return translationConfig
}

export {
    setTranslationConfig,
    getTranslationConfig
}